var map = {
	"./1/list-pattern1.svg": 857,
	"./1/list-pattern2.svg": 858,
	"./1/list-pattern3.svg": 859,
	"./1/pattern1.svg": 860,
	"./1/pattern2.svg": 861,
	"./1/pattern3.svg": 862,
	"./10/list-pattern1.svg": 863,
	"./10/list-pattern2.svg": 864,
	"./10/list-pattern3.svg": 865,
	"./10/pattern1.svg": 866,
	"./10/pattern2.svg": 867,
	"./10/pattern3.svg": 868,
	"./11/list-pattern1.svg": 869,
	"./11/list-pattern2.svg": 870,
	"./11/list-pattern3.svg": 871,
	"./11/pattern1.svg": 872,
	"./11/pattern2.svg": 873,
	"./11/pattern3.svg": 874,
	"./2/list-pattern1.svg": 875,
	"./2/list-pattern2.svg": 876,
	"./2/list-pattern3.svg": 877,
	"./2/pattern1.svg": 878,
	"./2/pattern2.svg": 879,
	"./2/pattern3.svg": 880,
	"./3/list-pattern1.svg": 881,
	"./3/list-pattern2.svg": 882,
	"./3/list-pattern3.svg": 883,
	"./3/pattern1.svg": 884,
	"./3/pattern2.svg": 885,
	"./3/pattern3.svg": 886,
	"./4/list-pattern1.svg": 887,
	"./4/list-pattern2.svg": 888,
	"./4/list-pattern3.svg": 889,
	"./4/pattern1.svg": 890,
	"./4/pattern2.svg": 891,
	"./4/pattern3.svg": 892,
	"./5/list-pattern1.svg": 893,
	"./5/list-pattern2.svg": 894,
	"./5/list-pattern3.svg": 895,
	"./5/pattern1.svg": 896,
	"./5/pattern2.svg": 897,
	"./5/pattern3.svg": 898,
	"./6/list-pattern1.svg": 899,
	"./6/list-pattern2.svg": 900,
	"./6/list-pattern3.svg": 901,
	"./6/pattern1.svg": 902,
	"./6/pattern2.svg": 903,
	"./6/pattern3.svg": 904,
	"./7/list-pattern1.svg": 905,
	"./7/list-pattern2.svg": 906,
	"./7/list-pattern3.svg": 907,
	"./7/pattern1.svg": 908,
	"./7/pattern2.svg": 909,
	"./7/pattern3.svg": 910,
	"./8/list-pattern1.svg": 911,
	"./8/list-pattern2.svg": 912,
	"./8/list-pattern3.svg": 913,
	"./8/pattern1.svg": 914,
	"./8/pattern2.svg": 915,
	"./8/pattern3.svg": 916,
	"./9/list-pattern1.svg": 917,
	"./9/list-pattern2.svg": 918,
	"./9/list-pattern3.svg": 919,
	"./9/pattern1.svg": 920,
	"./9/pattern2.svg": 921,
	"./9/pattern3.svg": 922,
	"./99/list-pattern1.svg": 923,
	"./99/pattern1.svg": 924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 963;